var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { register as registerReq } from "@/05-models/auth";
import { useErrorNotify } from "@/06-shared/lib/errorNotifier";
import { PopupButton, PopupInput, PopupWindow } from "@/06-shared/ui/popups";
import { useState } from "react";
export const Register = ({ isOpen, onSuccess, onClose }) => {
    const [login, setLogin] = useState("");
    const [password, setPassword] = useState("");
    const [inviteCode, setInviteCode] = useState("");
    const showError = useErrorNotify();
    const onRegister = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield registerReq({
                login: login,
                password: password,
                inviteCode: inviteCode
            });
            onSuccess();
        }
        catch (error) {
            showError(error);
        }
        finally {
            onClose();
        }
    });
    return (isOpen ? (_jsxs(PopupWindow, { name: "\u0420\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F", onClose: () => { onClose(); }, children: [_jsx(PopupInput, { name: "\u041B\u043E\u0433\u0438\u043D", setInput: (data) => setLogin(data), autoFocus: true }), _jsx(PopupInput, { name: "\u041F\u0430\u0440\u043E\u043B\u044C", setInput: (data) => setPassword(data), autoFocus: false }), _jsx(PopupInput, { name: "\u0418\u043D\u0432\u0430\u0439\u0442 \u043A\u043E\u0434", setInput: (data) => setInviteCode(data), onEnter: onRegister, autoFocus: false }), _jsx(PopupButton, { name: "[Ok]", onClick: () => onRegister() })] })) : null);
};
